/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Enhanced list method with metadata
 */
export const ViolationNotesListQueryParams = zod.object({
  "ordering": zod.string().optional(),
  "search": zod.string().optional(),
  "violation_id": zod.string().uuid().optional().describe('Filter notes to a single violation.')
})

export const ViolationNotesListResponse = zod.object({
  "metadata": zod.object({
  "totalNotes": zod.number(),
  "notesLast24h": zod.number(),
  "notesLast7d": zod.number(),
  "notesByUser": zod.record(zod.string(), zod.number()),
  "activeUsers": zod.number(),
  "notesByViolationStatus": zod.record(zod.string(), zod.number())
}).strict().describe('Metadata block of the violation-notes list response.\n\nField names mirror the camelCase keys ``ViolationNoteViewSet.list`` emits.'),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "userEmail": zod.string().email(),
  "violationCode": zod.string(),
  "propertyName": zod.string(),
  "note": zod.string().describe('The content of the note'),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().describe('Lightweight serializer for list views'))
}).strict().describe('The ``{metadata, results}`` envelope ``ViolationNoteViewSet.list``\nreturns. Declared so the generated SDK type reflects the real (un-paginated)\nresponse instead of drf-spectacular\'s guessed paginated wrapper (AMP-501).')

/**
 * ViewSet for managing violation notes.
 */



export const ViolationNotesCreateBody = zod.object({
  "violation": zod.string().uuid().describe('The violation this note is associated with'),
  "note": zod.string().min(1).describe('The content of the note')
}).describe('Detailed serializer for violation notes')

export const violationNotesCreateResponseUserOneUsernameMax = 150;


export const violationNotesCreateResponseUserOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const violationNotesCreateResponseUserOneEmailMax = 254;

export const violationNotesCreateResponseUserOnePhoneNumberMax = 128;



export const ViolationNotesCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "violation": zod.string().uuid().describe('The violation this note is associated with'),
  "violationCode": zod.string(),
  "user": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(violationNotesCreateResponseUserOneUsernameMax).regex(violationNotesCreateResponseUserOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(violationNotesCreateResponseUserOneEmailMax).optional(),
  "phoneNumber": zod.string().max(violationNotesCreateResponseUserOnePhoneNumberMax).optional()
}).strict(),
  "note": zod.string().describe('The content of the note'),
  "propertyName": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('Detailed serializer for violation notes')

/**
 * ViewSet for managing violation notes.
 */
export const ViolationNotesRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Violation Note.')
})

export const violationNotesRetrieveResponseUserOneUsernameMax = 150;


export const violationNotesRetrieveResponseUserOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const violationNotesRetrieveResponseUserOneEmailMax = 254;

export const violationNotesRetrieveResponseUserOnePhoneNumberMax = 128;



export const ViolationNotesRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "violation": zod.string().uuid().describe('The violation this note is associated with'),
  "violationCode": zod.string(),
  "user": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(violationNotesRetrieveResponseUserOneUsernameMax).regex(violationNotesRetrieveResponseUserOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(violationNotesRetrieveResponseUserOneEmailMax).optional(),
  "phoneNumber": zod.string().max(violationNotesRetrieveResponseUserOnePhoneNumberMax).optional()
}).strict(),
  "note": zod.string().describe('The content of the note'),
  "propertyName": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('Detailed serializer for violation notes')

/**
 * ViewSet for managing violation notes.
 */
export const ViolationNotesUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Violation Note.')
})




export const ViolationNotesUpdateBody = zod.object({
  "violation": zod.string().uuid().describe('The violation this note is associated with'),
  "note": zod.string().min(1).describe('The content of the note')
}).describe('Detailed serializer for violation notes')

export const violationNotesUpdateResponseUserOneUsernameMax = 150;


export const violationNotesUpdateResponseUserOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const violationNotesUpdateResponseUserOneEmailMax = 254;

export const violationNotesUpdateResponseUserOnePhoneNumberMax = 128;



export const ViolationNotesUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "violation": zod.string().uuid().describe('The violation this note is associated with'),
  "violationCode": zod.string(),
  "user": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(violationNotesUpdateResponseUserOneUsernameMax).regex(violationNotesUpdateResponseUserOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(violationNotesUpdateResponseUserOneEmailMax).optional(),
  "phoneNumber": zod.string().max(violationNotesUpdateResponseUserOnePhoneNumberMax).optional()
}).strict(),
  "note": zod.string().describe('The content of the note'),
  "propertyName": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('Detailed serializer for violation notes')

/**
 * ViewSet for managing violation notes.
 */
export const ViolationNotesPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Violation Note.')
})




export const ViolationNotesPartialUpdateBody = zod.object({
  "violation": zod.string().uuid().optional().describe('The violation this note is associated with'),
  "note": zod.string().min(1).optional().describe('The content of the note')
}).describe('Detailed serializer for violation notes')

export const violationNotesPartialUpdateResponseUserOneUsernameMax = 150;


export const violationNotesPartialUpdateResponseUserOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const violationNotesPartialUpdateResponseUserOneEmailMax = 254;

export const violationNotesPartialUpdateResponseUserOnePhoneNumberMax = 128;



export const ViolationNotesPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "violation": zod.string().uuid().describe('The violation this note is associated with'),
  "violationCode": zod.string(),
  "user": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(violationNotesPartialUpdateResponseUserOneUsernameMax).regex(violationNotesPartialUpdateResponseUserOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(violationNotesPartialUpdateResponseUserOneEmailMax).optional(),
  "phoneNumber": zod.string().max(violationNotesPartialUpdateResponseUserOnePhoneNumberMax).optional()
}).strict(),
  "note": zod.string().describe('The content of the note'),
  "propertyName": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict().describe('Detailed serializer for violation notes')

/**
 * ViewSet for managing violation notes.
 */
export const ViolationNotesDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Violation Note.')
})

export const ViolationNotesDestroyResponse = zod.void()

